<template>
  <QueryView
    ref="queryView"
    :table-config="tableConfig"
    search-label="Nombre"
    :town-selection="false"
    :region-selection="true"
    :province-selection="true"
  >
    <template #header>
      <Button
        class="query__category-button"
        icon="pi pi-filter"
        label="Habitantes"
        @click="toggleAdvancedSearch"
      ></Button>
    </template>
  </QueryView>
</template>

<script setup>
import {ref} from 'vue';
import {useClipboard} from '@vueuse/core';
import QueryView from '../QueryView';
import QueryTableConfig from '../query-table.view-config.js';
import {
  TOWNS_SCHEMA,
  TOWNS_FILTERS,
} from './query-towns-table.view-config.js';
import Button from 'primevue/button';
import {searchTown} from '@/api/town/town.api.js';
import {
  searchTownHtml,
  searchTownPdf,
  getTownPdf,
} from '@/api/town/town.api.pdf.js';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const queryView = ref();
const {copy} = useClipboard();
// #endregion

// #region Functions
function toggleAdvancedSearch() {
  if (!!queryView?.value?.toggleAdvancedSearch) {
    queryView.value.toggleAdvancedSearch();
  }
  return;
}
async function printTown(data) {
  const printRecord = queryView?.value?.printRecord ?? null;
  if (!!printRecord) {
    await printRecord(data.id, 'Población - ' + data.name, getTownPdf);
  }
}
async function htmlTownQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Poblaciones', searchTownHtml, 'html');
  }
}
async function printTownQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Poblaciones', searchTownPdf);
  }
}
async function goTown({
  coordinates,
  popPlus25k,
  pop5kto25k,
  pop1kto5k,
  popMinus1k,
  name,
  visible,
}) {
  let zoom = 10;
  const popArray = [popPlus25k, pop5kto25k, pop1kto5k, popMinus1k]
    .map((b) => b.toString())
    .join('-');
  switch (popArray) {
    case 'true-false-false-false':
      zoom = 10;
      break;
    case 'false-true-false-false':
      zoom = 10;
      break;
    case 'false-false-true-false':
      zoom = 12;
      break;
    case 'false-false-false-true':
      zoom = 12;
      break;
    default:
      zoom = 10;
      break;
  }
  const goCoordinates = queryView?.value?.goCoordinates;
  if (!!goCoordinates) {
    goCoordinates({coordinates, name, visible, zoom});
  }
}

function townToText({name, province, population, area, height}) {
  const res = `
    Nombre: ${name}
    Provincia: ${province}
    Nº de habitantes: ${population}
    Superficie (km2): ${area}
    Altitud (m): ${height}
    `;
  return res;
}
// #endregion
// functions previously defined
const tableConfig = new QueryTableConfig({
  title: '',
  api: searchTown,
  recordToText: townToText,
  copyClipboard: copy,
  htmlQuery: htmlTownQuery,
  printQuery: printTownQuery,
  printRecord: printTown,
  centerMap: goTown,
  schema: TOWNS_SCHEMA,
  filterFields: TOWNS_FILTERS,
});
//

// #region Effects, Hooks
// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped></style>
